import { cn } from "@gigpro/ui/tailwind/cn";
import { Collapsible as CollapsiblePrimitive } from "radix-ui";
import type * as React from "react";

const Collapsible = ({ className, ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Root>) => (
  <CollapsiblePrimitive.Root className={cn("group/collapsible", className)} {...props} />
);

const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

interface CollapsibleContentProps extends React.ComponentProps<typeof CollapsiblePrimitive.Content> {
  orientation?: "vertical" | "horizontal";
}

const CollapsibleContent = ({ ref, className, orientation = "vertical", ...props }: CollapsibleContentProps) => (
  <CollapsiblePrimitive.Content
    ref={ref}
    className={cn(
      "overflow-hidden",
      orientation === "vertical"
        ? "data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"
        : "data-[state=closed]:animate-collapsible-shut data-[state=open]:animate-collapsible-wide",
      className,
    )}
    {...props}
  />
);
CollapsibleContent.displayName = "CollapsibleContent";

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
